import '../../../vendors/layer_handler_ecc/layer_handler_eec';
import { setCookie } from '../../../utils/cookie_manager';
import { updatePricesInfo } from '../../../shared/update_prices/update_prices';

$(function () {
  let paginationUpdated = false;

  function init() {
    // Get search term from place to go select options and update title with it
    let $place = $('.results-header').find('.place');
    if ($place.length) {
      let text_to_replace = $('[name="vo_booking[place_to_go]"]').find('option[value=' + $place.text() + ']').first()
        .text();
      if (text_to_replace) {
        $place.text('"' + text_to_replace + '"');
        $place.closest('.t-h2').show();
      } else {
        $('.results-header').hide();
      }
    }

    // Query job to retrieve prices
    if ($('#job_id').length > 0) {
      let price_custom_message = $('#job_id').data('price-custom-message') || '0';
      watchJob($('#job_id').val(), price_custom_message);
    }


    $(document).on('change', '.js-myibe-toggle', function () {
      let url = $(this).data('url');
      let $text = $(this).closest('.js-toggle-wrapper').find('.js-toggle-text');
      let toggle_text = $(this).hasClass('active') ? $text.data('toggle-on') : $text.data('toggle-off');
      if ($(this).hasClass('active')) {setCookie('show_myibe_discount', 'true');} else {setCookie('show_myibe_discount', 'false', "-1");}
      // Change text near the toggle
      $text.html(toggle_text);
      $.ajax({
        type:     'GET',
        dataType: 'script',
        url:      url
      });
    });

    //sets default value for crsPricesUpdated variable
    if (localStorage.getItem('crsPricesUpdated')) {
      localStorage.setItem('crsPricesUpdated', 'false');
    }
  }

  function watchJob(jid, price_custom_message) {
    setTimeout(() => {
      let lang = document.documentElement.getAttribute('data-js-lang');
      lang = lang != 'es' ? '/' + lang : '';
      let $hotelMapLink = $('a.hotel-map-link');
      if (!$hotelMapLink.closest('.js-footer-filter-buttons').length) $hotelMapLink.hide();
      $.getJSON(lang + '/crs_availabilities_jobs/' + jid + '/?price_custom_message=' + price_custom_message, function (job) {
        // While the job is not finished
        if (job.at != job.total) {
          setTimeout(function () {
            watchJob(jid, price_custom_message);
          }, 1000);
        } else {
          $('#watch-job').remove();
          if (!$hotelMapLink.closest('.js-footer-filter-buttons').length) $hotelMapLink.show();
        }
        $(document).trigger('price_displayed');
        if (job.at == job.total) {
          sessionStorage.setItem('crs_prices', JSON.stringify(job));
          processValues(job);
        }
      });
    }, 5000);
  }

  function processPrices(div, html_replacements, orders) {
    let result = html_replacements[$(div).data('id')];
    let order = orders[$(div).data('id')];
    if (result) {
      let $this = $(div);
      let $fb_btn;
      $this.removeClass('wait');
      $this.find('.call-to-action').replaceWith(result);
      $fb_btn = $this.find('a.js-book-btn');
      if (typeof $fb_btn !== 'undefined') {
        let link_url = $fb_btn.attr('href');
        let activMyIbeValue = ($('.js-myibe-toggle').hasClass('active') ? 1 : 0);
        if (typeof link_url !== 'undefined') {
          link_url = link_url + (link_url.indexOf('?') != -1 ? '&activeMiIB=' + activMyIbeValue : 'activeMiIB=' + activMyIbeValue);
          $fb_btn.attr('href', link_url);
        }
      }

      if ($this.find('.badges-and-price').length) {
        let $r = $('<div></div>').html(result);
        let $type = ($r.find('.type').length == 0 ? $r.find('.prev-type') : $r.find('.type'));
        let $highlight = $r.find('.highlight');
        let $hint_cnt = $r.find('.hint-cnt');
        let $not_available = $r.find('.not-available-message');
        let $price_cnt = $('<div class="price-cnt call-to-action"></div>');
        let datas = $r.find('[data-curr-converter][data-hotel-id]').data();
        $price_cnt.append($type, $highlight, $hint_cnt, $not_available);
        $this.find('.badges-and-price').html($price_cnt);
        // Añadimos los datas para el conversor:
        try {
          if (datas !== undefined) {
            $.each(datas, function (key, value) {
              $this.find('.badges-and-price .highlight').attr('data-' + key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(), value);
              $this.find('.badges-and-price .highlight').addClass('t-price');
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
      if (IB.currentDevice === 'mobile') {
        let $call_to_action = $this.find('.call-to-action');
        $this.find('.info-price').append($call_to_action.find('.highlight').parent('div'), $call_to_action.find('.hint-cnt'));
      }
      LayerHandlerEec.pushVisibleProducts($this.find('.call-to-action a[data-ecc-product]'));
    }
  }

  function processMyIbePills(div, html_myibes) {
    let result = html_myibes[$(div).data('id')];
    if (result) {
      let $this = $(div);
      $this.find('.myibe-discount').replaceWith(result);
      if ($('.js-myibe-toggle').hasClass('active')) {$this.find('.myibe-discount').show();} else {$this.find('.myibe-discount').hide();}
    }
  }

  function processMyIbeTags(div, html_myibe_tags) {
    let result = html_myibe_tags[$(div).data('id')];
    if (result) {
      let $this = $(div);
      $this.find('.discounts').replaceWith(result);
    }
  }

  function processMyIbeFancybox(div, html_myibe_discounts) {
    let result = html_myibe_discounts[$(div).data('id')];
    if (result) {
      let $this = $(div);
      let $discountsFancybox = $this.find('#discounts-' + $(div).data('code'));
      if($discountsFancybox !== undefined)
        $discountsFancybox.html(result);
      if ($('.js-myibe-toggle').hasClass('active') === true) {
        $('.discounts-fancybox .desc .my-iberostar').removeClass('hidden');
      } else {
        $('.discounts-fancybox .desc .my-iberostar').addClass('hidden');
      }
    }
  }

  function processValues(job) {
    $('.result-hotel:not(.completed)').each(function (i, div) {
      if (job?.hotel_ids_order_price && !paginationUpdated) {
        let paginationUpdateEvent = new Event('pagination:update');
        paginationUpdateEvent.hotelIDs = job.hotel_ids_order_price;
        paginationUpdateEvent.hotelIDsWithoutPrice = job.hotel_ids_without_price;
        paginationUpdateEvent.fromCRSPricesSync = true;
        paginationUpdated = true;
        document.dispatchEvent(paginationUpdateEvent);
      }
      if (job.html_replacements) {
        processPrices(div, JSON.parse(job.html_replacements), JSON.parse(job.orders));
      }

      if (job.html_myibes) {
        processMyIbePills(div, JSON.parse(job.html_myibes));
      }

      if (job.html_myibe_tags) {
        processMyIbeTags(div, JSON.parse(job.html_myibe_tags));
      }

      if (job.html_myibe_discounts) {
        processMyIbeFancybox(div, JSON.parse(job.html_myibe_discounts));
      }
    });

    //Forces prices to be updated with the correct currency type
    IB.currencyForm.forceUpdate();

    //updates crsPricesUpdated to true, because there is a new crsPrices variable
    localStorage.setItem('crsPricesUpdated', 'true');
    const updateCTAs = new Event('updateCTAs');
    document.getElementById('fb-results').dispatchEvent(updateCTAs);
    if(job?.hotel_ids_without_price) {
      let paginationUpdateEvent = new Event('availability:finished');
      paginationUpdateEvent.idsToAppend = JSON.parse(job.hotel_ids_without_price);
      paginationUpdateEvent.fromCRSPricesSync = true;
      document.dispatchEvent(paginationUpdateEvent);
    }
    if (job.html_replacements) {
      $(document).trigger('availability:processed', [Object.keys(JSON.parse(job.html_replacements))]);
    }

    updatePricesInfo()
  }

  function forceCRSprices(job) {
    job = job || sessionStorage.getItem('crs_prices');
    job = JSON.parse(job);
    processValues(job);
  }

  function replaceHtmlWithCRSinfo(job) {
    makeReplacements(job, '.result-hotel:not(.completed)');
    $(document).trigger('price_displayed');

    if (job.html_replacements) {
      $(document).trigger('availability:processed', [Object.keys(JSON.parse(job.html_replacements))]);
    }
    updatePricesInfo()
  }

  function makeReplacements(job, elements) {
    $(elements).each(function (i, div) {
      if (job.html_replacements) {
        processPrices(div, JSON.parse(job.html_replacements), JSON.parse(job.orders));
      }

      if (job.html_myibes) {
        processMyIbePills(div, JSON.parse(job.html_myibes));
      }

      if (job.html_myibe_tags) {
        processMyIbeTags(div, JSON.parse(job.html_myibe_tags));
      }

      if (job.html_myibe_discounts) {
        processMyIbeFancybox(div, JSON.parse(job.html_myibe_discounts));
      }

      $(div).find('[data-tooltip]').each(function (index, element) {
        IB.tooltip.init($(element));
      });
    });
  }

  IB.booking_results = {
    init:          init,
    watchJob:      watchJob,
    processValues: processValues,
    forceCRSprices: forceCRSprices
  };
}(jQuery));
